import React, { useState, useEffect } from 'react';
import qs from 'querystring';

// For IE11
import { jsx as _jsx } from "react/jsx-runtime";
const fromEntries = Object.fromEntries || (arr => arr.reduce((obj, _ref) => {
  let [key, val] = _ref;
  obj[key] = val;
  return obj;
}, {}));
function BuyerConnect(_ref2) {
  let {
    urlBase,
    year,
    makeCode,
    makeLabel,
    modelCode,
    modelLabel,
    trimCode,
    trimLabel,
    zipCode,
    pageName,
    /* `pageName` is only used for analytics. */
    height: initialHeight = '450px',
    listingType
  } = _ref2;
  const [height, setHeight] = useState(initialHeight);
  const [src, setSrc] = useState('');
  useEffect(() => {
    const messageHandler = _ref3 => {
      let {
        data,
        origin
      } = _ref3;
      if (origin.match(/(^|\.)(autotrader|kbb)\.com(:\d+)?$/) && data && data.type === 'onFdpqWidgetHeightChanged' && !Number.isNaN(Number.parseFloat(data.height))) {
        setHeight(data.height);
      }
    };
    global.addEventListener('message', messageHandler);
    return () => {
      global.removeEventListener('message', messageHandler);
    };
  }, [setHeight]);
  useEffect(() => {
    const optional = fromEntries(Object.entries({
      vehicleYear: year,
      atcmakecode: makeCode,
      atcmakename: makeLabel,
      atcmodelcode: modelCode,
      atcmodelname: modelLabel,
      atctrimcode: trimCode,
      atctrimname: trimLabel,
      zipcode: zipCode,
      pagename: pageName,
      vehicleListingType: listingType
    }).filter(_ref4 => {
      let [, value] = _ref4;
      return value;
    }));
    const queryString = qs.stringify({
      origin: global.location.origin,
      ...optional
    });
    setSrc(urlBase + '&' + queryString);
  }, [year, makeCode, makeLabel, modelCode, modelLabel, trimCode, trimLabel, zipCode, pageName, urlBase, listingType]);
  return urlBase ? /*#__PURE__*/_jsx("iframe", {
    title: "New Car Price Quote",
    src: src,
    style: {
      border: 'none',
      width: '100%',
      height,
      transitionProperty: 'height',
      transitionDuration: '0.25s',
      transitionTimingFunction: 'ease',
      backgroundColor: '#fff'
    }
  }) : null;
}
export default /*#__PURE__*/React.memo(BuyerConnect);